<template>
  <div class="new-dashboard-page">
    <div class="row">
      <div class="col-md-12">
        <div class="card d-flex flex-row justify-content-between align-items-center px-4 px-md-5">
          <div>
            <h2 class="font-custom">Selamat Datang {{ organizationName }}</h2>
          </div>
          <img :src="`${baseURL}${logo}`" alt="" class="logo" />
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="card p-5">
          <div id="customerMapContainer" style="height: 500px; width: 100%;"></div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-5" id="chart-analysis-section">
      <p class="card-title">Analisis Aset Data Center {{ analisTitle ? analisTitle : '' }}</p>
      <button v-if="selectedCustomerName" @click="resetData" class="btn">
        <UndoOutlined />
        <span class="ml-2">Reset</span>
      </button>
    </div>
    <div class="row mt-4">
      <div class="col-md-6 col-sm-12">
        <div class="card px-4 px-lg-5 d-flex flex-row align-items-center justify-content-between">
          <div>
            <p class="card-title">
              Total Aset
            </p>
            <h2 class="font-custom-large-value">
              {{ formatNumberToLocaleString(totalAssetNumber) }}
            </h2>
          </div>
          <img src="../../assets/img/totalAsset.png" class="asset-image" alt="" />
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div
          class="card  px-4 px-lg-5 py-4 d-flex flex-row align-items-center justify-content-between"
        >
          <div class="d-flex flex-column align-items-between ">
            <p class="card-title">
              Total Nilai Aset
            </p>
            <h2 class="font-custom-large-value">{{ formatCurrencyToShort(totalAssetPrice) }}</h2>
            <p class="font-custom3-small">{{ formatRupiah(totalAssetPrice) }}</p>
          </div>
          <img src="../../assets/img/totalNilaiAsset.png" alt="" class="asset-image" />
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6 col-sm-12">
        <div class="card p-4 p-lg-5">
          <p class="card-title">
            Total per Assets Category
          </p>
          <div class="chart-container">
            <canvas id="totalAssetsCategoryChart"></canvas>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="card p-4 p-lg-5">
          <p class="card-title">
            Value per Assets Category
          </p>
          <div class="chart-container">
            <canvas id="valueAssetsCategoryChart"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4" v-if="selectedCustomerId">
      <div class="col-12">
        <div class="card p-5">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <p class="card-title">
              List Assets
            </p>
          </div>

          <!-- <a-table
            :columns="tableColumns"
            :data-source="filteredCustomerList"
            :pagination="false"
            :row-key="record => record.id"
            :custom-row="
              record => {
                return {
                  onClick: event => {
                    handleCustomerClick(record)
                  },
                }
              }
            "
            class="antd-table-custom"
            style="overflow-x: scroll;"
          >
            <template #index="{ index }">
              {{ index + 1 }}
            </template>
            <template #assetSubcategories="{ record }">
              <div class="asset-subcategories-container">
                <template v-if="Object.keys(filteredSubcategories(record.assetDetails)).length > 0">
                  <a-tag
                    v-for="(subcat, subcatName) in filteredSubcategories(record.assetDetails)"
                    :key="subcatName"
                    color="#EDF2FF"
                    class="asset-tag"
                  >
                    {{ subcatName }}
                    <CheckOutlined :style="{ color: '#389E0D' }" v-if="subcat.isAvailable" />
                    <CloseOutlined :style="{ color: 'red' }" v-else />
                  </a-tag>
                </template>
                <template v-else>
                  <span class="no-subcategory-message"
                    >Tidak ada subkategori yang sesuai filter ini.</span
                  >
                </template>
              </div>
            </template>
            <template #filterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters }">
              <div style="padding: 8px">
                <a-radio-group
                  :value="selectedKeys[0]"
                  @change="
                    e => {
                      setSelectedKeys(e.target.value ? [e.target.value] : [])
                      activeSubcategoryFilter = e.target.value
                      confirm()
                    }
                  "
                  class="radio-filter-group"
                >
                  <a-radio value="available">Tersedia (Centang)</a-radio>
                  <a-radio value="not-available">Tidak Tersedia (Silang)</a-radio>
                  <a-radio value="">Semua</a-radio>
                </a-radio-group>
                <div class="filter-actions-container">
                  <a-button
                    size="small"
                    style="width: 90px"
                    @click="
                      () => {
                        clearFilters()
                        activeSubcategoryFilter = ''
                        confirm()
                      }
                    "
                  >
                    Reset
                  </a-button>
                </div>
              </div>
            </template>
            <template #filterIcon="{ filtered }">
              <FilterFilled :style="{ color: filtered ? '#1890ff' : '#bfbfbf' }" />
            </template>
          </a-table> -->
          <dcOwnerAsset :customer-id="selectedCustomerId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import { Chart, registerables } from 'chart.js'
import { Modal, notification, message } from 'ant-design-vue'

import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
delete L.Icon.Default.prototype._getIconUrl

// Memberitahu Leaflet lokasi file ikon yang benar menggunakan 'require'
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
// =====
// import Indonesia from '../../components/Map/indonesia.vue'
import { assetsByCategory } from '../../services/axios/modc/ats'
import { Table as ATable, Tag as ATag, Button as AButton, Radio as ARadio } from 'ant-design-vue'
import { CheckOutlined, CloseOutlined, FilterFilled, UndoOutlined } from '@ant-design/icons-vue'
import { baseURL } from '../../services/axios'
import dcOwnerAsset from '../../views/assets/dcOwnerAsset.vue'
Chart.register(...registerables)

export default {
  name: 'NewDashboardBNPB',
  components: {
    dcOwnerAsset,
    // Indonesia,
    // ATable,
    // ATag,
    // AButton,
    // ARadio,
    // ARadioGroup: ARadio.Group,
    // CheckOutlined,
    // CloseOutlined,
    // FilterFilled,
    // UndoOutlined,
  },
  setup() {
    const accountName = ref('BNPB Pusat')
    const totalWilayah = ref(34)
    const customerList = ref([])
    const filteredCustomerList = ref([])
    const totalAssetNumber = ref(0)
    const totalAssetPrice = ref(0)
    const organizationType = ref('Perdaerah')
    let map = null
    let markersLayer = null
    const totalCategoryChartInstance = ref(null)
    const valueCategoryChartInstance = ref(null)

    const allAssetsData = ref(null)
    const selectedCustomerName = ref(null)

    const activeSubcategoryFilter = ref('')
    // Tambahkan ref baru untuk kontrol responsif legenda
    const isLargeScreen = ref(window.innerWidth >= 1025)

    // Fungsi untuk mengupdate status isLargeScreen
    const initializeCustomerMap = () => {
      if (map) {
        map.remove() // Hapus instance peta lama jika ada
      }
      // console.log(filteredCustomerList.value[0].latitude, 'iniinisiasi')
      // console.log(filteredCustomerList.value[0].longitude, 'iniinisiasi')
      map = L.map('customerMapContainer').setView(
        [filteredCustomerList.value[0].latitude, filteredCustomerList.value[0].longitude],
        8,
      )
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map)
      markersLayer = L.featureGroup().addTo(map)

      updateCustomerPins()
    }
    const updateCustomerPins = () => {
      if (!markersLayer) return
      markersLayer.clearLayers()
      try {
        const validCustomers = filteredCustomerList.value.filter(c => c.latitude && c.longitude)
        if (validCustomers.length === 0) return

        validCustomers.forEach(customer => {
          L.marker([customer.latitude, customer.longitude])
            .addTo(markersLayer)
            .bindPopup(`<b>${customer.name}</b>`)
            .on('click', () => handleCustomerClick(customer))
        })
        map.fitBounds(markersLayer.getBounds(), { padding: [50, 50] })
      } catch (error) {
        // console.log(error)
        notification.error({
          message: 'Gagal',
          description: 'Gagal memuat data pelanggan untuk peta.',
        })
      }
    }

    const checkScreenSize = () => {
      isLargeScreen.value = window.innerWidth >= 1025
      // Panggil ulang displayData untuk merecreate chart dengan pengaturan legend yang baru
      if (allAssetsData.value) {
        if (selectedCustomerName.value) {
          // Jika ada customer terpilih, cari data customer tersebut
          const currentCustomer = customerList.value.find(
            c => c.name === selectedCustomerName.value,
          )
          if (currentCustomer) {
            displayData({
              totalAssets: currentCustomer.customerTotals.totalAssets,
              totalValue: currentCustomer.customerTotals.totalValue,
              categoryDetails: currentCustomer.categoryDetails,
            })
          }
        } else {
          // Jika tidak ada customer terpilih (grand totals)
          displayData(allAssetsData.value.grandTotals)
        }
      }
    }

    // Fungsi untuk format angka biasa (integer) ke string dengan pemisah ribuan
    const formatNumberToLocaleString = value => {
      if (typeof value !== 'number') return value
      return value.toLocaleString('id-ID') // Contoh: 1.234.567
    }

    // Fungsi untuk format nilai Rupiah lengkap
    const formatRupiah = value => {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      }).format(value)
    }
    const selectedProvinceName = ref()
    const handleChangeAssetData = provinceName => {
      // provinceName adalah string, misal "Aceh"
      // console.log('inidariindo (provinceName):', provinceName) // Output: "Aceh"
      // console.log('islandMapping.value:', islandMapping.value) // Output: [{Aceh:{...}}, {Jawa Barat:{...}}]

      // Jika provinceName adalah null (misal dari reset di map ketika klik pulau tanpa data)
      if (!provinceName) {
        resetData()
        return
      }

      selectedCustomerName.value = null // Reset customer yang terpilih
      selectedProvinceName.value = provinceName // Set nama provinsi yang terpilih
      analisTitle.value = provinceName

      // --- Perbaikan di sini: Looping islandMapping.value untuk mencari data provinsi ---
      let provinceData = null
      for (const item of islandMapping.value) {
        // Iterasi array islandMapping
        const currentProvinceName = Object.keys(item)[0] // Ambil nama provinsi dari objek di dalam array
        if (currentProvinceName === provinceName) {
          // Bandingkan dengan provinceName yang dicari
          provinceData = item[currentProvinceName] // Jika sama, ambil data provinsinya
          break // Keluar dari loop setelah ditemukan
        }
      }
      // --- Akhir perbaikan ---
      // console.log(provinceData, 'cekini')
      if (provinceData && provinceData.totalAssets > 0) {
        // Pastikan ada data aset
        totalAssetNumber.value = provinceData.totalAssets
        totalAssetPrice.value = provinceData.totalValue

        // Gunakan categoryDetails yang sudah diagregasi dari provinceData
        displayData({
          totalAssets: provinceData.totalAssets,
          totalValue: provinceData.totalValue,
          categoryDetails: provinceData.categoryDetails || {}, // Gunakan categoryDetails dari provinceData
        })

        // Filter list customer berdasarkan provinsi yang dipilih
        filteredCustomerList.value = customerList.value.filter(c => c.provinsi === provinceName)

        // Scroll ke bagian chart
        const chartSection = document.getElementById('chart-analysis-section')
        if (chartSection) {
          chartSection.scrollIntoView({ behavior: 'smooth' })
        }
      } else {
        // Jika provinsi tidak memiliki data, tampilkan notifikasi dan reset
        notification.info({
          message: 'Informasi',
          description: `Provinsi ${provinceName} tidak memiliki data data center.`,
        })
        resetData() // Mungkin lebih baik reset jika tidak ada data
      }
    }
    // Fungsi untuk format nilai mata uang menjadi singkatan (T, M, Jt)
    const formatCurrencyToShort = num => {
      if (typeof num !== 'number') return num
      if (num >= 1000000000000) {
        return (num / 1000000000000).toFixed(2).replace(/\.00$/, '') + ' T'
      }
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(2).replace(/\.00$/, '') + ' M'
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(2).replace(/\.00$/, '') + ' Jt'
      }
      return num.toLocaleString('id-ID') // Untuk nilai di bawah 1 Jt, tetap format lokal
    }

    const createTotalCategoryChart = categoryTotalData => {
      const ctxCategory = document.getElementById('totalAssetsCategoryChart').getContext('2d')
      if (totalCategoryChartInstance.value) {
        totalCategoryChartInstance.value.destroy()
      }
      totalCategoryChartInstance.value = new Chart(ctxCategory, {
        type: 'bar',
        data: {
          labels: categoryTotalData.labels,
          datasets: [
            {
              label: 'Total Aset',
              data: categoryTotalData.data,
              backgroundColor: ['#FB545C', '#B3B4FC', '#2D9AED', '#90C400', '#E3C51D', '#FF9609'],
              borderColor: ['#FB545C', '#B3B4FC', '#2D9AED', '#90C400', '#E3C51D', '#FF9609'],
              borderWidth: 1,
            },
          ],
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              beginAtZero: true,
              grid: {
                display: false,
              },
            },
            y: {
              grid: {
                display: false,
              },
            },
          },
        },
      })
    }
    const islandMapping = ref({})
    const createValueCategoryChart = categoryValueData => {
      const ctxValue = document.getElementById('valueAssetsCategoryChart').getContext('2d')
      if (valueCategoryChartInstance.value) {
        valueCategoryChartInstance.value.destroy()
      }
      valueCategoryChartInstance.value = new Chart(ctxValue, {
        type: 'pie',
        data: {
          labels: categoryValueData.labels,
          datasets: [
            {
              label: 'Nilai Aset (Rp)',
              data: categoryValueData.data,
              backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#9966FF',
                '#FF9F40',
                '#8a2be2',
                '#00CED1',
                '#FF4500',
                '#ADFF2F',
                '#A4DD00',
                '#68BC00',
                '#C4DD00',
                '#F7F700',
                '#FAA43A',
                '#F47F24',
                '#EB6300',
                '#B92E34',
                '#AA1D24',
                '#8C000B',
                '#5A0007',
                '#000000',
                '#3E4653',
                '#727D8C',
                '#9CA4B1',
                '#B9C0C9',
                '#D1D7E0',
                '#E7EBEE',
              ],
              borderColor: '#FFFFFF',
              borderWidth: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: isLargeScreen.value, // Gunakan ref isLargeScreen di sini
              position: 'right',
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.label || ''
                  if (label) {
                    label += ': '
                  }
                  if (context.raw !== null) {
                    label += formatRupiah(context.raw)
                    const total = context.dataset.data.reduce((sum, val) => sum + val, 0)
                    const percentage =
                      total === 0 ? '0.00%' : ((context.raw / total) * 100).toFixed(2) + '%'
                    label += ` (${percentage})`
                  }
                  return label
                },
              },
            },
          },
        },
      })
    }

    const processCategoryDetails = categoryDetails => {
      const labels = Object.keys(categoryDetails)
      const totalData = labels.map(label => categoryDetails[label].total)
      const valueData = labels.map(label => categoryDetails[label].value)

      return {
        categoryTotal: { labels: labels, data: totalData },
        categoryValue: { labels: labels, data: valueData },
      }
    }

    const displayData = data => {
      totalAssetNumber.value = data.totalAssets
      totalAssetPrice.value = data.totalValue

      const processed = processCategoryDetails(data.categoryDetails)

      createTotalCategoryChart(processed.categoryTotal)
      createValueCategoryChart(processed.categoryValue)
    }
    const logo = ref('')
    const organizationName = ref('')
    const fetchAssetsData = async () => {
      try {
        const storedUserData = localStorage.getItem('userData')
        const userData = JSON.parse(storedUserData)
        organizationType.value = userData.user.organizationType
        organizationName.value = userData.user.organizationName
        const assets = await assetsByCategory(userData.user.organizationId)
        logo.value = userData.user.logo
        allAssetsData.value = assets
        customerList.value = assets.customers
        filteredCustomerList.value = assets.customers
        islandMapping.value = assets.provinceTotals
        // console.log(islandMapping.value)
        displayData(assets.grandTotals)
        // if (organizationType.value === 'Province') {
        // }
        initializeCustomerMap()
      } catch (error) {
        console.error('Error fetching assets:', error)
      }
    }
    const analisTitle = ref('')
    const selectedCustomerId = ref(null)
    const handleCustomerClick = customer => {
      const chartSection = document.getElementById('chart-analysis-section') // ID target scroll
      if (chartSection) {
        chartSection.scrollIntoView({ behavior: 'smooth' }) // Scroll halus ke section chart
      }
      analisTitle.value = customer.name
      selectedCustomerName.value = customer.name
      selectedCustomerId.value = customer.id

      displayData({
        totalAssets: customer.customerTotals.totalAssets,
        totalValue: customer.customerTotals.totalValue,
        categoryDetails: customer.categoryDetails,
      })
    }

    const resetData = () => {
      selectedCustomerName.value = null
      if (allAssetsData.value) {
        displayData(allAssetsData.value.grandTotals)
      }
    }

    const filteredSubcategories = assetDetails => {
      const filtered = {}
      const originalKeys = Object.keys(assetDetails)

      if (!originalKeys.length) {
        return filtered
      }

      if (!activeSubcategoryFilter.value) {
        return assetDetails
      }

      for (const subcatName of originalKeys) {
        const subcat = assetDetails[subcatName]
        if (
          (activeSubcategoryFilter.value === 'available' && subcat.isAvailable) ||
          (activeSubcategoryFilter.value === 'not-available' && !subcat.isAvailable)
        ) {
          filtered[subcatName] = subcat
        }
      }
      return filtered
    }

    const tableColumns = [
      {
        title: 'No',
        dataIndex: 'index',
        key: 'index',
        slots: { customRender: 'index' },
      },
      {
        title: 'Nama',
        dataIndex: 'name',
        key: 'name',
        width: 200,
      },
      {
        title: 'Alamat',
        dataIndex: 'address',
        key: 'address',
        width: 400,
      },
      {
        title: 'Aset Subkategori',
        dataIndex: 'assetSubcategories',
        key: 'assetSubcategories',
        // width: 500,
        slots: {
          customRender: 'assetSubcategories',
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon',
        },
      },
    ]

    onMounted(() => {
      fetchAssetsData()
    })

    onBeforeUnmount(() => {
      if (totalCategoryChartInstance.value) {
        totalCategoryChartInstance.value.destroy()
      }
      if (valueCategoryChartInstance.value) {
        valueCategoryChartInstance.value.destroy()
      }
    })

    return {
      selectedCustomerId,
      accountName,
      totalWilayah,
      customerList,
      totalAssetNumber,
      totalAssetPrice,
      formatRupiah,
      formatCurrencyToShort, // Export fungsi baru
      formatNumberToLocaleString, // Export fungsi baru
      selectedCustomerName,
      handleCustomerClick,
      resetData,
      tableColumns,
      filteredSubcategories,

      activeSubcategoryFilter,
      handleChangeAssetData,
      islandMapping,
      analisTitle,
      filteredCustomerList,
      // API_BASE_URL,
      logo,
      organizationType,
      organizationName,
      baseURL,
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap');

.new-dashboard-page {
  padding: 20px;
}

.card {
  background-color: #ffffff;
  border-radius: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  height: 100%;
}

.card.d-flex.flex-row.justify-content-between.align-items-center.px-5 {
  padding: 30px;
}
.card.px-5.py-4 {
  padding: 30px;
}
.card.p-5 {
  padding: 30px;
}

.font-custom {
  font-family: 'Rubik', sans-serif;
  font-weight: 600;
  color: #044188;
  font-size: 40px;
}

.font-custom2 {
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  color: #044188;
}

.font-custom3 {
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  color: #6c757d;
}

/* Gaya baru untuk nilai besar yang diformat */
.font-custom-large-value {
  font-family: 'Rubik', sans-serif;
  font-weight: 700; /* Lebih tebal dari font-custom biasa */
  color: #044188;
  font-size: 36px; /* Ukuran lebih besar dari font-custom3 */
  margin-bottom: 0px; /* Hapus margin bawah default p */
}

/* Gaya baru untuk nilai asli di bawahnya */
.font-custom3-small {
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  color: #6c757d;
  font-size: 14px; /* Ukuran lebih kecil */
  margin-top: 5px; /* Sedikit jarak dari nilai besar */
}

.mt-4 {
  margin-top: 1.5rem;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.text-center {
  text-align: center;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

/* Responsivitas untuk col-md-6 dan col-sm-12 */
.col-12,
.col-md-4,
.col-md-6,
.col-md-8,
.col-sm-12 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #0056b3;
  border-color: #0056b3;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.flex-column {
  flex-direction: column;
}

.asset-subcategories-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.asset-tag {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: black;
}

.antd-table-custom {
  border: none;
  box-shadow: none;
}

.ant-table-row {
  cursor: pointer;
}
.ant-table-row:hover {
  background-color: #e6f7ff;
}

.customer-name-display {
  font-size: 24px;
  margin-left: 8px;
}

.radio-filter-group {
  display: flex;
  flex-direction: column;
  padding: 8px;
}
.radio-filter-group .ant-radio-wrapper {
  margin-left: 0 !important;
  margin-bottom: 8px;
}
.filter-actions-container {
  display: flex;
  justify-content: flex-end;
  padding: 8px;
  border-top: 1px solid #e8e8e8;
}

.no-subcategory-message {
  color: #8c8c8c;
  font-style: italic;
  font-size: 0.9em;
  padding: 5px;
}
.logo {
  width: 120px;
  height: 133px;
}
.card-title {
  font-size: 20px;
}
.asset-image {
  width: 144px;
  height: 144px;
}

.chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}

@media (max-width: 1025px) {
  .chart-container {
    position: relative;
    height: 250px;
    width: 100%;
  }
  .font-custom {
    font-size: 20px;
  }

  .font-custom2 {
    font-size: 12px;
  }
  .logo {
    width: 90px;
    height: 103px;
  }
  .card-title {
    font-size: 16px;
  }

  .asset-image {
    width: 80px;
    height: 80px;
  }
}

#chart-analysis-section {
  scroll-margin-top: 40px;
}
</style>
